import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaGoogle, FaRocket, FaLayerGroup, FaShieldAlt } from 'react-icons/fa';
import { useSelector } from "react-redux";
import Language_i18 from '../../js/useNationalLanguage.jsx';
import Login_home from '../../auth/login_home_main.jsx';
import { Cookies } from '../../index.js';
import HomeHeroSection from './home_firts_main.jsx';
import HomeContentSections from './home_menu_main.jsx';
import { HomeLatestTechnicalInsightsSection, HomeEngineeringNotesSection } from './home_ai.jsx';
import translations from './homehealing.json';
import { isLocalHost } from '../../shared/host_utils.js';

function Hometruyenthanh() {
  const { lang } = Language_i18();
  const safeLang = translations[lang] ? lang : 'en';
  const latest_version = useSelector(state => state.latest_version);
  const [tipsVipLoading, setTipsVipLoading] = useState(false);
  const [tipsVipTotal, setTipsVipTotal] = useState(null);
  const [tipsVipArticles, setTipsVipArticles] = useState([]);
  const [digitalSuiteTotal, setDigitalSuiteTotal] = useState(null);
  const [digitalSuiteArticles, setDigitalSuiteArticles] = useState([]);
  const [engineeringNotesTotal, setEngineeringNotesTotal] = useState(null);
  const [engineeringNotesArticles, setEngineeringNotesArticles] = useState([]);
  const HOME_CACHE_TTL_MS = 60 * 60 * 1000;
  const domain = window.location.hostname;
  const isHustMedia = domain.includes("hust.media");
  const getMainDomain = () => {
    const parts = window.location.hostname.split('.');
    return parts.length > 2 ? parts[parts.length - 2] : parts[0];
  };
  const main_domain = !isLocalHost(window.location.hostname)
    ? (Cookies.get("main_domain") || getMainDomain() || "hust")
    : (Cookies.get("main_domain") || "hust");
  const heroTitleKey = `heroTitle_${main_domain}`;
  const heroTitle = translations[safeLang]?.[heroTitleKey] || translations[safeLang]?.heroTitle_main;
  const homeDescriptionKey = `home_description_${main_domain}`;
  const homeDescription =
    translations[safeLang]?.[homeDescriptionKey] ||
    translations[safeLang]?.home_description_main;
  const isNofake = main_domain == 'nofake';
  const isHustTarget = isHustMedia || main_domain == 'hust';
  const ctaLink = isNofake
    ? "/shop/check/home"
    : ((latest_version == 3 && isHustTarget) ? "/shop/category/tips_vip" : "/shop/auth/login_home");
  const ctaReload = !isNofake && (latest_version == 3 && isHustTarget);
  const ctaLabel = (latest_version == 3 && isHustTarget)
    ? translations[safeLang]?.tryForFree_2
    : translations[safeLang]?.tryForFree_1;
  const hideCtaIcon = (latest_version == 3 && isHustTarget);
  const ctaLinkProps = ctaReload ? { to: ctaLink, reloadDocument: true } : { to: ctaLink };
  const docLinkProps = { to: "/next/docs/overview", reloadDocument: true };
  const showTipsVipLibrary = latest_version == 3 && isHustTarget;
  const shouldUseClientCache = !isLocalHost(window.location.hostname);
  const homeCacheKey = `home_payload_${main_domain}_${safeLang}`;
  const libraryTitle = safeLang == 'vi' ? "Bài viết mới nhất" : "Latest Articles";
  const librarySubtitle = "These articles explore how scalable web platforms are designed, optimized, and kept stable as they grow over time. They cover Hybrid Cloud architecture, scalable server deployment, hybrid frontend structure, backend and middleware design, API, MQTT, and AI integration, data flow optimization, and performance monitoring. Together, these topics show how practical architecture and stable operation help a platform stay reliable, integrate smoothly, and continue reaching new users as demand increases.";
  const viewAllLabel = safeLang == 'vi' ? "Xem tất cả bài viết" : "View all articles";
  const updatedLabel = safeLang == 'vi' ? "Cập nhật" : "Updated";
  const totalArticlesCount = Number.isFinite(tipsVipTotal)
    ? tipsVipTotal
    : (Array.isArray(tipsVipArticles) ? tipsVipArticles.length : 0);

  // Giữ nguyên style kính mờ sang trọng
  const glassPanel = "relative bg-slate-950/40 bg-hust-glass backdrop-blur-md border border-white/10 hover:border-hust-pink/50 transition-all duration-500 shadow-lg hover:shadow-hust-pink/20 rounded-2xl sm:rounded-3xl pt-4 pr-3 pb-4 pl-3 sm:pt-6 sm:pr-6 sm:pb-6 sm:pl-6 group";

  const techStackItems = [
    {
      icon: FaLayerGroup,
      iconClassName: "text-3xl sm:text-4xl text-purple-400 mb-3 sm:mb-4",
      title: translations[safeLang]?.mmoAppFramework,
      description: translations[safeLang]?.mmoDescription,
    },
    {
      icon: FaRocket,
      iconClassName: "text-3xl sm:text-4xl text-pink-400 mb-3 sm:mb-4",
      title: translations[safeLang]?.aiSmartAssistant,
      description: translations[safeLang]?.aiDescription,
    },
    {
      icon: FaShieldAlt,
      iconClassName: "text-3xl sm:text-4xl text-blue-400 mb-3 sm:mb-4",
      title: translations[safeLang]?.appAnalyticsDashboard,
      description: translations[safeLang]?.analyticsDescription,
    },
  ];

  useEffect(() => {
    if (!(latest_version == 3 && isHustTarget)) {
      setTipsVipLoading(false);
      setTipsVipTotal(null);
      setTipsVipArticles([]);
      setDigitalSuiteTotal(null);
      setDigitalSuiteArticles([]);
      setEngineeringNotesTotal(null);
      setEngineeringNotesArticles([]);
      return;
    }

    let hasHydratedFromCache = false;
    if (shouldUseClientCache && typeof window !== 'undefined' && window.sessionStorage) {
      try {
        const raw = window.sessionStorage.getItem(homeCacheKey);
        if (raw) {
          const parsed = JSON.parse(raw);
          const age = Date.now() - Number(parsed?.at || 0);
          if (parsed?.data && age >= 0 && age <= HOME_CACHE_TTL_MS) {
            const cached = parsed.data;
            const cachedTipsVipData = Array.isArray(cached?.tipsVipData) ? cached.tipsVipData : [];
            const cachedDigitalSuiteData = Array.isArray(cached?.digitalSuiteData) ? cached.digitalSuiteData : [];
            const cachedEngineeringNotesData = Array.isArray(cached?.engineeringNotesData) ? cached.engineeringNotesData : [];
            setTipsVipTotal(Number.isFinite(Number(cached?.tipsVipTotal)) ? Number(cached.tipsVipTotal) : cachedTipsVipData.length);
            setTipsVipArticles(cachedTipsVipData.slice(0, 5));
            setDigitalSuiteTotal(Number.isFinite(Number(cached?.digitalSuiteTotal)) ? Number(cached.digitalSuiteTotal) : cachedDigitalSuiteData.length);
            setDigitalSuiteArticles(cachedDigitalSuiteData.slice(0, 2));
            setEngineeringNotesTotal(
              Number.isFinite(Number(cached?.engineeringNotesTotal)) ? Number(cached.engineeringNotesTotal) : cachedEngineeringNotesData.length
            );
            setEngineeringNotesArticles(cachedEngineeringNotesData.slice(-2));
            hasHydratedFromCache = true;
          } else {
            window.sessionStorage.removeItem(homeCacheKey);
          }
        }
      } catch {
        window.sessionStorage.removeItem(homeCacheKey);
      }
    }

    setTipsVipLoading(!hasHydratedFromCache);
    axios
      .get('https://hust.media/api/content/get_content.php')
      .then((response) => {
        const payload = response?.data || {};
        const totalData = Number(payload?.count_tips_vip ?? payload?.total_data);
        const tipsVipData = Array.isArray(payload?.data?.tips_vip)
          ? payload.data.tips_vip
          : [];
        const digitalSuiteData = Array.isArray(payload?.data?.digital_suite)
          ? payload.data.digital_suite
          : [];
        const totalDigitalSuite = Number(payload?.count_digital_suite);
        const engineeringNotesData = Array.isArray(payload?.data?.engineering_notes)
          ? payload.data.engineering_notes
          : [];
        const totalEngineeringNotes = Number(payload?.count_engineering_notes);
        const latestArticles = tipsVipData.slice(0, 5);
        const latestDigitalSuite = digitalSuiteData.slice(0, 2);
        const latestEngineeringNotes = engineeringNotesData.slice(-2);
        setTipsVipTotal(Number.isFinite(totalData) ? totalData : tipsVipData.length);
        setTipsVipArticles(latestArticles);
        setDigitalSuiteTotal(Number.isFinite(totalDigitalSuite) ? totalDigitalSuite : digitalSuiteData.length);
        setDigitalSuiteArticles(latestDigitalSuite);
        setEngineeringNotesTotal(
          Number.isFinite(totalEngineeringNotes) ? totalEngineeringNotes : engineeringNotesData.length
        );
        setEngineeringNotesArticles(latestEngineeringNotes);
        if (shouldUseClientCache && typeof window !== 'undefined' && window.sessionStorage) {
          try {
            window.sessionStorage.setItem(
              homeCacheKey,
              JSON.stringify({
                at: Date.now(),
                data: {
                  tipsVipTotal: Number.isFinite(totalData) ? totalData : tipsVipData.length,
                  tipsVipData,
                  digitalSuiteTotal: Number.isFinite(totalDigitalSuite) ? totalDigitalSuite : digitalSuiteData.length,
                  digitalSuiteData,
                  engineeringNotesTotal: Number.isFinite(totalEngineeringNotes) ? totalEngineeringNotes : engineeringNotesData.length,
                  engineeringNotesData,
                },
              })
            );
          } catch {
            // Ignore storage quota or parsing issues.
          }
        }
      })
      .catch((error) => {
        console.error('prefetch tips_vip error:', error);
        setTipsVipTotal(null);
        setTipsVipArticles([]);
        setDigitalSuiteTotal(null);
        setDigitalSuiteArticles([]);
        setEngineeringNotesTotal(null);
        setEngineeringNotesArticles([]);
      })
      .finally(() => {
        setTipsVipLoading(false);
      });
  }, [latest_version, isHustTarget, shouldUseClientCache, homeCacheKey, HOME_CACHE_TTL_MS]);

  const formatDate = (value) => {
    if (!value) return '';
    const parsedDate = new Date(String(value).replace(' ', 'T'));
    if (Number.isNaN(parsedDate.getTime())) return String(value).slice(0, 10);
    return parsedDate.toLocaleDateString(safeLang == 'vi' ? 'vi-VN' : 'en-US');
  };

  return (
    <div className="min-h-screen bg-transparent w-full text-white relative overflow-hidden">

      <div className="mx-auto max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 pt-2 sm:pt-4 pb-8 space-y-4 sm:space-y-5">
        <style>{`
          @keyframes fadeUp {
            0% { opacity: 0; transform: translateY(18px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .enter-hero { opacity: 1; animation: fadeUp 0.28s ease forwards; }
          .enter-slider { opacity: 1; animation: fadeUp 0.28s ease 0.03s forwards; }
          .enter-stack { opacity: 1; animation: fadeUp 0.28s ease 0.06s forwards; }
          .enter-library { opacity: 1; animation: fadeUp 0.28s ease 0.08s forwards; }
          .enter-features { opacity: 1; animation: fadeUp 0.28s ease 0.1s forwards; }
        `}</style>

		        <HomeHeroSection
		          glassPanel={glassPanel}
		          heroTitle={heroTitle}
		          homeDescription={homeDescription.replace("{domain}", domain)}
		          ctaLinkProps={ctaLinkProps}
		          ctaLabel={ctaLabel}
		          hideCtaIcon={hideCtaIcon}
		          docLinkProps={docLinkProps}
		          main_domain={main_domain}
		          latest_version={latest_version}
              tipsVipLoading={tipsVipLoading}
		        />

	        {showTipsVipLibrary && (
            <HomeLatestTechnicalInsightsSection
              glassPanel={glassPanel}
              totalArticlesCount={totalArticlesCount}
              librarySubtitle={librarySubtitle}
              tipsVipArticles={tipsVipArticles}
              updatedLabel={updatedLabel}
              formatDate={formatDate}
              viewAllLabel={viewAllLabel}
              tipsVipLoading={tipsVipLoading}
              safeLang={safeLang}
            />
          )}

        <HomeContentSections
          glassPanel={glassPanel}
          systemComponentsTitle={translations[safeLang]?.systemComponents}
          techStackItems={techStackItems}
          main_domain={main_domain}
          isHustMedia={isHustMedia}
          latest_version={latest_version}
          digitalSuiteArticles={digitalSuiteArticles}
          digitalSuiteTotal={digitalSuiteTotal}
        />

        <HomeEngineeringNotesSection
          glassPanel={glassPanel}
          engineeringNotesArticles={engineeringNotesArticles}
          engineeringNotesTotal={engineeringNotesTotal}
        />

      </div>
    </div>
  );
}

export default Hometruyenthanh;
